import { createContext } from 'react';
import { UsuarioDoLicenciadoOutput } from '../services/UsuarioService';

interface SessaoUsuarioContextProps {
  usuariosLicenciados: UsuarioDoLicenciadoOutput[];
  sessao?: UsuarioDoLicenciadoOutput | null;
  setSessao?: (sessao?: UsuarioDoLicenciadoOutput | null) => void;
  habilitaNeoassist: boolean;
}

const SessaoUsuarioContext = createContext<SessaoUsuarioContextProps>({
  usuariosLicenciados: [],
  sessao: null,
  setSessao: () => { },
  habilitaNeoassist: true
});

export default SessaoUsuarioContext;